import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { UrlService } from '@service/url/url.service';
import { CarrierDTOResponse, RestService } from 'cargo-chief-commons';
import { CarrierService } from '@service/carrier/carrier.service';
import { UtilService } from '@service/util/util.service';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { LoadingSpinnerDialogComponent } from '../loading-spinner-dialog/loading-spinner-dialog.component';

@Component({
	selector: 'app-carrier-search',
	templateUrl: './carrier-search.component.html',
	styleUrls: ['./carrier-search.component.scss'],
})
export class CarrierSearchComponent {
	@Input() carrierSelected: CarrierDTOResponse = null;
	@Input() parsedEmailId = null;
	@Input() emailFrom = null;
	@Input() isForTasks: boolean = false;
	@Output() updatedCarrier: EventEmitter<any> = new EventEmitter();
	separatorKeysCodes: number[] = [ENTER];
	isCarrierSearchEnabled = true;
	isLoading = false;

	addOnBlur = false;

	carrierCtrl = new UntypedFormControl();
	listOfCarriers: any[];
	carrierNames: string[];
	selectedCarrier = -1;

	@ViewChild('carrierInput') carrierInput: ElementRef;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;

	constructor(
		public dialog: MatDialog,
		private urlService: UrlService,
		private restService: RestService,
		private carrierService: CarrierService,
		public utilService: UtilService
	) {}

	ngAfterViewInit() {
		this.carrierCtrl.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => (this.isLoading = true)),
				switchMap((value) => {
					const url = this.urlService.searchCarriers(0, 5);
					return this.restService
						.POST(url, { businessName: value, inNetwork: false, ignoreContactCount: true })
						.pipe(finalize(() => (this.isLoading = false)));
				})
			)
			.subscribe((carriers) => {
				this.listOfCarriers = carriers['content'];
				this.carrierNames = [];
				this.listOfCarriers.map((carrier) => {
					this.carrierNames.push(carrier.businessName);
				});
			});

		this.matAutocomplete._keyManager.change.subscribe((index) => {
			if (index >= 0) {
				this.selectedCarrier = index;
			}
		});
	}

	ngOnChanges() {
		if (this.carrierSelected != undefined && this.carrierSelected != null) {
			this.isCarrierSearchEnabled = false;
		}
	}

	enableSearch() {
		this.isCarrierSearchEnabled = true;
		this.carrierSelected = null;
		this.updatedCarrier.emit(this.carrierSelected);
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		let businessName = null;
		if (
			!this.utilService.isNullOrUndefined(event.option) &&
			!this.utilService.isNullOrUndefined(event.option.value)
		) {
			businessName = event.option.value;
		}
		if (!this.utilService.isNullOrUndefined(businessName)) {
			this.carrierSelected = this.listOfCarriers.filter((carrier) => {
				if (carrier.businessName.trim() == businessName.trim()) {
					return carrier;
				}
			})[0];
			this.isCarrierSearchEnabled = false;
			!this.utilService.isNullOrUndefined(this.carrierInput.nativeElement)
				? (this.carrierInput.nativeElement.value = '')
				: '';
			if (!this.isForTasks) {
				const url = this.urlService.parsedCapacityEmailUpdateCarrierId(
					this.parsedEmailId,
					this.carrierSelected.id
				);
				const payload = {
					contact_type: 'OTHER',
					contact_email: this.emailFrom,
				};
				const loadingDialog = this.dialog.open(LoadingSpinnerDialogComponent, {
					width: '300px',
				});
				this.restService.POST(url, payload).subscribe(
					(result) => {
						this.carrierSelectionUpdated();
						loadingDialog.close();
					},
					(error) => {
						if (error.status == 201) {
							this.carrierSelectionUpdated();
						}
						loadingDialog.close();
						this.utilService.showSnackbar(
							'Unable to carrier ID now. Please try again later.',
							SNACKBAR.ERROR,
							SNACKBAR.ACTION
						);
					}
				);
			} else {
				this.updatedCarrier.emit(this.carrierSelected);
			}
		}
	}

	carrierSelectionUpdated() {
		this.utilService.showSnackbar(
			'Carrier ID for all the trucks have been changed successfully.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
		this.updatedCarrier.emit(this.carrierSelected);
	}

	add(event: MatChipInputEvent) {
		if (this.matAutocomplete.isOpen && this.selectedCarrier >= 0) {
			this.carrierSelected = this.listOfCarriers[this.selectedCarrier];
		}
		this.selectedCarrier = -1;
	}
}
